import {makeStyles} from '@material-ui/core';
import cx from 'classnames';
import React from 'react';
import {ChipOption} from 'screens/DealsScreen/config';
import {rieltor} from 'styles/theme';
import {Badge} from '../UserMenu/UserMenuItem';

const useStyles = makeStyles(theme => ({
  chipsWrapper: {
    display: 'flex',
    flexFlow: 'row nowrap',
    columnGap: '16px',
    paddingBottom: '16px',
  },
  counter: {
    color: rieltor.gray4,
  },
  chip: {
    display: 'flex',
    flexFlow: 'row nowrap',
    columnGap: '4px',
    alignItems: 'center',
    padding: '4px 10px',
    height: '40px',
    borderRadius: '4px',
    fontFamily: rieltor.fontFamily,
    fontSize: '13px',
    fontWeight: 700,
    backgroundColor: '#fff',
    color: '#000',

    '&:hover': {
      backgroundColor: rieltor.grayFill,
      cursor: 'pointer',
    },
    '&:disabled': {
      color: rieltor.gray4,
    },
    '&.active': {
      backgroundColor: rieltor.purple,
      color: '#fff',

      '& $counter': {
        color: rieltor.whiteTransparent,
      }
    },
  },
  chipSmall: {
    padding: '4px 8px',
    height: '30px',
    fontSize: '12px',
    fontWeight: 500,
    backgroundColor: rieltor.grayFill,

    '&:not(.active):hover': {
      backgroundColor: '#fff',
    },
  },
}));

interface ChipsSquareProps {
  value: any;
  options: ChipOption[];
  onChange: (nextValue: any) => void;
  disabled?: boolean;
  allowEmpty?: boolean;
  customClass?: string;
  size?: 'medium' | 'small';
}

const ChipsSquare = (
  {value, options, onChange, disabled, allowEmpty, customClass, size = 'medium'}: ChipsSquareProps
) => {
  const classes = useStyles();

  return (
    <div className={classes.chipsWrapper}>
      {
        options.map(option => {
          const isActive = value === option.value.toString();
          const handleClick = (disabled || (isActive && !allowEmpty))
            ? undefined
            : () => {
              onChange(option);
            };

          return (
            <div
              className={cx(classes.chip, {
                [classes.chipSmall]: size === 'small',
                active: isActive,
              }, option.chipClassName, customClass)}
              key={option.value}
              onClick={handleClick}
            >
              {option.startIcon}
              <span style={{whiteSpace: 'nowrap'}}>{option.label}</span>
              {option.middleIcon}

              {
                option.counterPlus && option.counterPlus > 0
                  ? <Badge value={`+${option.counterPlus}`}/>
                  : <span className={classes.counter}>{option.counter}</span>
              }
              {option.endIcon}
            </div>
          );
        })
      }
    </div>
  );
};

export default ChipsSquare;
